export default "__VITE_ASSET__c529f0fa__"